// This is a bounded UI cache lease, never an API authorization mechanism.
// It is recorded only after a successful server authentication; the API still
// authenticates every request. Only the read-only client fallback may use it.
const SESSION_KEY = 'beresto_verified_kiosk_session_v1';
const MAX_OFFLINE_AGE_MS = 60 * 60 * 1000;

export function forgetVerifiedKioskSession() {
  try { localStorage.removeItem(SESSION_KEY); } catch (_) { /* storage unavailable */ }
}

export function rememberVerifiedKioskSession(token, account) {
  try {
    const encoded = String(token || '').split('.')[0].replace(/-/g, '+').replace(/_/g, '/');
    const payload = JSON.parse(atob(encoded.padEnd(Math.ceil(encoded.length / 4) * 4, '=')));
    const accountId = Number(account?.id);
    const expiresAt = Math.min(Number(payload.exp), Date.now() + MAX_OFFLINE_AGE_MS);
    if (!accountId || Number(payload.accountId) !== accountId || !Number.isFinite(expiresAt) || expiresAt <= Date.now()) {
      forgetVerifiedKioskSession();
      return;
    }
    localStorage.setItem(SESSION_KEY, JSON.stringify({ token, accountId, expiresAt }));
  } catch (_) { forgetVerifiedKioskSession(); }
}

export function hasVerifiedOfflineKioskSession() {
  try {
    const session = JSON.parse(localStorage.getItem(SESSION_KEY) || 'null');
    const account = JSON.parse(localStorage.getItem('kioskAccount') || 'null');
    return Boolean(session && session.token === localStorage.getItem('authToken')
      && session.accountId === Number(account?.id) && session.expiresAt > Date.now());
  } catch (_) { return false; }
}
